import { get as m, camelCase as f, pick as d } from "lodash-es";
import { getCurrentInstance as y, computed as a, useAttrs as k, ref as v, watch as A } from "vue";
function w(t, c = {}) {
  const { inheritEventHandlers: e = !1 } = c, r = y(), u = a(() => {
    const n = m(r, "vnode.type.emits", []);
    return (Array.isArray(n) ? n : Object.keys(n)).map((s) => f(`on-${s}`));
  }), o = k(), l = Object.keys(t), i = v([]);
  return A(
    () => Object.keys(t),
    (n) => {
      i.value = n.filter(
        (s) => !l.includes(s) && // event handler on a component (@XXX) will be converted to property onXXX on production
        // and should not be passed down unless the user of this function wants it
        // or it might cause unwanted results
        // related issues: [EDC-5088]
        (e || !u.value.includes(s))
      );
    },
    { immediate: !0 }
  ), a(() => ({
    ...d(t, i.value),
    ...o
  }));
}
function O(t) {
  return t;
}
function g(t, c, e) {
  return {
    ...t,
    install: (r) => {
      r.component(c, t), e && r.directive(e.directiveName, e.directive);
    }
  };
}
export {
  O as makeType,
  w as useGetFilledAttrs,
  g as withInstall
};
